import React, { Component } from 'react'

export default class WorksAdonai extends Component {
    render() {
        return (
            <div class="modal" id="worksadonai" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-full" role="document">
                    <div class="modal-content">
                    <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
            </div>
                        <div class="modal-header">
                            <h5 class="modal-title"><strong>&quot;Quel che so di Adonai&quot; </strong>(romanzo): <em>Italic-peQuod, 2010, Milano.</em></h5>
                            
                        </div>
                        <div class="modal-body p-4" id="result">


                            <div align="left">



                                <br/><br/>
                                    Quel che so di Adonai è la storia di una “questione privata” che si innesta su un tema di drammatica attualità, quale quello dell’immigrazione.
                                    Michele è un affermato architetto che segue con passione anche la campagna ereditata dal padre. Divorziato da parecchi anni, con due figli già grandi e una relazione stabile con una compagna che vive in un’altra città, conduce una vita relativamente serena e tranquilla. Fino alla sera fatidica in cui mentre sta rientrando in città, sulla tangenziale investe con l’auto e uccide un giovane immigrato extracomunitario.
                                    L’evento ha su di lui un effetto dirompente. Non gli vengono imputate gravi colpe, perché al momento dell’incidente non superava il limite di velocità e non ha potuto in alcun modo evitare l’impatto. Tuttavia non riesce a darsi pace e ad accettare l’accaduto. Le persone che ha attorno gli ripetono che non deve sentirsi colpevole, che si è trattato solo di una tragica fatalità e cercano di convincerlo che la cosa migliore è dimenticare, passare oltre. Lui, al contrario, riesce a sopportare quella che sta diventando un’autentica ossessione solo cercando di capire chi il ragazzo al quale ha tolto la vita.
                                    Si sa ben poco di lui, solo che si chiamava Adonai ed era un immigrato clandestino, di origine eritrea. Nessuno si presenta per identificarlo e le Autorità si preparano ad archiviare il caso, mentre anche dal punto di vista giudiziario le conseguenze del fatto sembrano poco rilevanti.
                                    Michele però non riesce a riprendere la vita di prima. Sia nel lavoro che nei rapporti con le persone, compreso quelle più care, prova un crescente senso di estraneità, di allontanamento. L’unico modo che ha di ritrovarsi è compiere una sua personale indagine su Adonai. Riesce a scoprire qualcosa in più su di lui, ma ancora non gli basta e continua a cercare. Un tratto alla volta si trova a seguire a ritroso il percorso che ha condotto il giovane immigrato a incrociare tragicamente il proprio destino col suo.
                                    La storia è imperniata su questa ricerca, attraverso la quale Michele verrà a contatto con una serie di persone, luoghi e situazioni legate alla drammatica realtà dell’immigrazione. Sempre più lontano dal proprio universo di prima, che l’incidente sembra aver reso invivibile, costruirà anche un percorso di crescita personale che lo porterà a una nuova e inattesa esperienza di vita.
                                    
 <br/><br/>


                                        <strong>ne hanno scritto:</strong> <br/><br/>

                                            Chiara Turrini, L’Adige, 4 maggio 2010<br/>
                                                Carlo Martinelli, Il Trentino, 31 maggio 2010<br/>
                                                    Sergio Pent, Tuttolibri (La Stampa) 21 agosto 2010<br/>
                                                        Stefano Zangrando, Alias (Il Manifesto) 9 ottobre 2010<br/>
                                                            Alessandro de Bertolini, Corriere della sera/Corriere del Trentino, 4 maggio 2010<br/>
                                                                Augusto Goio, Vita Trentina, 15 agosto 2010<br/>
                                                                    Alessandro Genovese, L’Adige, 6 giugno 2010<br/>
                                                                        Stefano Zangrando, Il Trentino, ottobre 2010<br/>
                                                                            Fahreneith , Radio 3, Il libro del giorno 2 agosto 2010<br/>
                                                                                Massimo Mazzalai, intervista Rai 3 sabato 26 giugno 2010<br/>



</div>











            </div>









            <div align="center">

<strong> Selezione Stampa</strong>
<table border="0" align="center" cellspacing="7">
    <tr>
       <td align="center" width="100">Alias (inserto cultura de Il Manifesto),
        9/ott/2010, recensione di Stefano Zangrando.(8k)</td> <td><a href="rec\adonai-zangrando-alias.zip"><img
        src="./img/rec/adonai-zang-small.png"
        alt="scarica in formato zip" 
	width="151" height="280"></img></a>
        </td>
 </tr> <tr>
        <td align="center" width="100">La Stampa, 21/ago/2010:
        "Il sogno spezzato di Adonai" di Sergio Pent.(41k)</td> <td><a href="rec\adonai-pent-stampa.zip"><img
        src="./img/rec/adonai-pent-small.jpg" 
alt="scarica in formato zip"
width="156"
        height="258"></img></a>
        </td>
</tr> 
   
</table>
</div>








                                                                            <div class="modal-footer">
                                                                                <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
                                                                            </div>
        </div>
    </div>
</div>


                                                                )
                                                              }
                                                            }
